import { getRuntime } from './runtime';
export function registerWidget(name, widget) {
    const runtime = getRuntime();
    runtime.registerWidget({
        name,
        render: widget,
    });
}
